import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'app-menu-dropdown',
  templateUrl: './menu-dropdown.component.html',
  styleUrls: ['./menu-dropdown.component.scss']
})
export class MenuDropdownComponent {
  @Input() item: any;
  @Input() rolesUsuario: string[] = [];
  @Input() nivel = 0;
  @Output() cerrarMenu = new EventEmitter<void>();

  isMobile: boolean = false;
  dropdownOpen: { [key: number]: boolean } = {};

  constructor() {
    this.checkIfMobile(); // Inicializa el estado de isMobile

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.dropdownOpen[this.item.id] = false;
    this.checkIfMobile();
  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 991; // Ancho común para móviles
  }

  cerrarMenuEvt() {
    this.cerrarMenu.emit();
  }

  validateAccessMenu(item: any): boolean {
    if (!item?.rol || item.rol === "") {
      return item?.visible ?? false;
    }
    return this.rolesUsuario.some(rol => item?.rol.includes(rol));
  }

  toggleDropdown(itemId: number) {
    if (this.isMobile) {
      this.dropdownOpen[itemId] = !this.dropdownOpen[itemId]; // Alterna el estado en móvil
    } else {
      //this.dropdownOpen[itemId] = !this.dropdownOpen[itemId]; // Alterna el estado en desktop
    }
  }

  isDropdownOpen(itemId: number): boolean {
    return this.dropdownOpen[itemId] || false; // Devuelve false si no está definido
  }

  ngAfterViewInit() {
    this.toggleDropdown(this.item.id);
  }
}
